import { axiosInterceptor } from "app/services/http-services/request-interceptor";
import SysRecord from "app/class/record";

export interface GateBootstrapResponse {
    page: SysRecord;
    widgets: SysRecord[];
}

const readBootstrap = async (path: string, publicOnly = false): Promise<GateBootstrapResponse> => {
    const response = await axiosInterceptor.get(path, {
        params: publicOnly ? { public: true } : undefined,
    });

    return response.data?.data;
};

export const getGateBootstrap = (slug: string, publicOnly = false) =>
    readBootstrap(`/api/gates/${encodeURIComponent(slug)}/bootstrap`, publicOnly);

export const getGateLandingBootstrap = () =>
    readBootstrap("/api/gates/landing/bootstrap");
